import React, { createContext, useContext, ReactNode } from 'react';
import { EventForUser } from 'legacy/events/types';
import { UserLean } from 'legacy/user/types';

interface EventPageContextType {
  event: EventForUser;
  user: UserLean | null;

  toggleManageEvent: () => void;
  toggleScanQRModal: () => void;
  toggleShareModal: () => void;
  setIsTicketModalOpen: (isOpen: boolean) => void;
  toggleViewContactsModal: () => void;
  toggleCheckout: () => void;
  viewGuests: () => void;

  isManageEventModalOpen: boolean;

  canShare: boolean;
  priceRangeNoDiscount: string;
  isLoggedIn: boolean;
}

const EventPageContext = createContext<EventPageContextType | undefined>(
  undefined
);

interface EventPageProviderProps {
  children: ReactNode;
  value: EventPageContextType;
}

export const EventPageProvider: React.FC<EventPageProviderProps> = ({
  children,
  value
}) => (
  <EventPageContext.Provider value={value}>
    {children}
  </EventPageContext.Provider>
);

export const useEventPageContext = () => {
  const context = useContext(EventPageContext);
  if (context === undefined) {
    throw new Error(
      'useEventPageContext must be used within an EventPageProvider'
    );
  }
  return context;
};

export default EventPageContext;
